// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"_3FBVlno7uH2nveivbMCmW6"};